module.exports = __webpack_public_path__ + "static/media/01_FairField-university.8c4f539b.gif";